var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 621.83 583.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "206.3 167.98 199.23 175.05 446.78 175.05 412.6 209.25 408.42 213.41 388.44 233.39 140.89 233.39 123.79 250.5 116.68 257.6 82.53 291.74 82.52 291.74 82.52 291.75 116.68 325.9 140.86 350.08 388.4 350.08 408.42 370.1 412.6 374.26 446.75 408.43 199.22 408.43 206.3 415.53 233.37 442.59 257.57 466.79 288.82 498.04 291.73 500.96 315.89 525.13 591.8 525.13 583.47 533.47 577.63 539.3 536.37 580.57 533.45 583.48 291.73 583.48 233.37 525.13 206.3 498.05 175.03 466.79 41.27 333.02 0 291.75 0.01 291.74 41.27 250.49 116.68 175.07 116.71 175.05 123.78 167.98 247.55 44.2 288.82 2.93 291.73 0.03 291.75 0 621.83 0 618.89 2.95 583.47 38.36 577.63 44.2 563.49 58.34 315.94 58.34 291.73 82.55 288.82 85.47 257.58 116.69 247.56 126.72 233.37 140.9 206.3 167.98"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.322815d90fd43743eb764151636e50ab.svg";
export { ForwardRef as ReactComponent };